export class ErrorMessages {
  static readonly SOMETHING_WENT_WRONG = "Something went wrong!";
  static readonly RESET_TOKEN_EXPIRE_ERROR = "The reset link is no longer valid. Please request a new one to reset your password.";
  static readonly DEFAULT_ERROR_TITLE = "Error";
}
